//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import vm from "../../main.js";
export default {
  name: "notice",
  data() {
    return {
      sort: "DESC",
      searchData: {},
      noticeList: [],
      page: 0,
      wrapperHeight: 0,
      allLoaded: false,
      categoryId: 6,
      _allow_anonymous: true,
      articleId: this.$route.params.id,
      article: null,
      cxcs:false
    };
  },

  methods: {
    getArticleDetail() {
      this.$loadingShow();
      this.$get(
        "/api/before-login/get-article/" +
          this.articleId +
          "?_allow_anonymous=true"
      )
        .then(data => {
          console.log("11111", data);
          this.article = data;
          if (data && data.title) {
            document.title = data.title;
          }
          this.$loadingHide();
        })
        .catch(() => this.$loadingHide());
    },
    backLastPage(){
        window.location.href = 'https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzk0NzI2MjQ0MA==&scene=110#wechat_redirect'
      
    },
     GetRequest() {
      var url = window.location.href; //获取url中"?"符后的字串
      if (url.indexOf("?") != -1) { //判断是否有参数
      var str = url.substr(1); //从第一个字符开始 因为第0个是?号 获取所有除问号的所有符串
      str = str.split("="); //用等号进行分隔 （因为知道只有一个参数 所以直接用等号进分隔 如果有多个参数 要用&号分隔 再用等号进行分隔）
        this.cxcs = true
      }
    }

  },
  mounted() {


    this.GetRequest()
    let url = window.location.href.split("#")[0];
    let _this = this;
    this.$get(`/api/wechat/getJsSdkVar?url=${url}`).then(res => {
      wx.config({
        debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
        appId: res.appId, // 必填，公众号的唯一标识
        timestamp: res.timestamp, // 必填，生成签名的时间戳
        nonceStr: res.nonceStr, // 必填，生成签名的随机串
        signature: res.signature, // 必填，签名
        jsApiList: [
          "onMenuShareAppMessage",
          "onMenuShareTimeline",
          "onMenuShareQQ",
          "onMenuShareQZone"
        ] // 必填，需要使用的JS接口列表
      });

      // wx.updateTimelineShareData({
      //   title: "11111111", // 分享标题
      //   link: window.location.href, // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
      //   imgUrl: "../../../static/img/logo_yuhong.png", // 分享图标
      //   success: function() {
      //     // 设置成功
      //     console.log("成功1");
      //   }
      // });
      console.log(window.location.href);
      wx.ready(function() {
        //需在用户可能点击分享按钮前就先调用
        wx.onMenuShareTimeline({
          title: _this.article.title, // 分享标题
          link: window.location.href+'?cxcs=1', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "http://wx.qlogo.cn/mmopen/T6ml2X5x1WaMCl8EE8khNjicAECcOvibibNzNWXib4nw5IUuEkTzPiaLPhLiaX0Sav0Ssarvz3FMrhJcPl6Pictrvia8005PeHfdgmmic/64", // 分享图标
          success: function() {
            // 设置成功
            console.log("成功2");
          }
        });

        wx.onMenuShareAppMessage({
          title: _this.article.title, // 分享标题
          link: window.location.href+'?cxcs=1', // 分享链接，该链接域名或路径必须与当前页面对应的公众号JS安全域名一致
          imgUrl:
            "http://wx.qlogo.cn/mmopen/T6ml2X5x1WaMCl8EE8khNjicAECcOvibibNzNWXib4nw5IUuEkTzPiaLPhLiaX0Sav0Ssarvz3FMrhJcPl6Pictrvia8005PeHfdgmmic/64", // 分享图标
          success: function() {
            // 设置成功
            console.log("成功2");
          }
        });
      });
      wx.error(function(res) {
        console.log("2323", res);
        //config信息验证失败会执行error函数，如签名过期导致验证失败，具体错误信息可以打开config的debug模式查看，也可以在返回的res参数中查看，对于SPA可以在这里更新签名。
      });
    });
    this.getArticleDetail();
  }
};



// WEBPACK FOOTER //
// ./src/page/home/biddingDel.vue